<template>
    <div class="measurements-page">
        <div class="row">
            <div class="col-12">
                <h1>{{ $tr.measurements.begin.title }}</h1>
            </div>
        </div>
        <div class="row">
            <div class="tabs col-12">
                <ul>
                    <li :class="{ active: activeTab === 0 || activeTab === null }"
                        @click="activeTab = 0; forceValidate = false" v-html="$tr.measurements.begin.tableMeasureBtn"></li>
                    <li :class="{ active: activeTab === 1 }" @click="activeTab = 1; forceValidate = false" v-html="$tr.measurements.begin.bodyMeasureBtn"></li>
                    <li :class="{ active: activeTab === 2 }" @click="activeTab = 2; forceValidate = false" v-html="$tr.measurements.begin.shirtMeasureBtn"></li>
                </ul>
                <div class="mobile-tabs-switch" :class="{ active: activeTab === 0 }" @click="toggleMobileTab(0)">
                    <span v-html="$tr.measurements.begin.tableMeasureBtn"></span>
                    <i></i>
                </div>
                <div class="tabs-content" :class="{ active: activeTab === 0 || activeTab === null }">
                    <MeasurementsTable/>
                </div>
                <div class="mobile-tabs-switch" :class="{ active: activeTab === 1 }" @click="toggleMobileTab(1)">
                    <span v-html="$tr.measurements.begin.bodyMeasureBtn"></span>
                    <i></i>
                </div>
                <div class="tabs-content" :class="{ active: activeTab === 1 }">
                    <MeasurementsForm :baseCategories="baseCategories" type="body"
                                      :validate="forceValidate && activeTab === 1"/>
                </div>
                <div class="mobile-tabs-switch" :class="{ active: activeTab === 2 }" @click="toggleMobileTab(2)">
                    <span v-html="$tr.measurements.begin.shirtMeasureBtn"></span>
                    <i></i>
                </div>
                <div class="tabs-content" :class="{ active: activeTab === 2 }">
                    <MeasurementsForm :baseCategories="baseCategories" type="shirt"
                                      :validate="forceValidate && activeTab === 2"/>
                </div>
            </div>
            <div class="col-12 mt-2 desktop-only">
                <div class="proceed-box">
                    <h3 class="heading">{{ $tr.product.totalPrice }} <strong>{{ $db.totalPrice() }}</strong></h3>
                    <div class="buttons-wrapper">
                        <Button @click="$emit('goToStep', '-1')" type="go-back" size="small">
                            {{ $tr.backBtn }}
                        </Button>
                        <Button @click="nextStep()" type="black" size="lg" :disabled="!allowNextButton"
                                :class="{ disabled: !allowNextButton }">
                            {{ $tr.nextStepBtn }}
                        </Button>
                    </div>
                </div>
            </div>
            <div class="not-desktop">
                <BottomBar @goToStep="$emit('goToStep', $event)" :customButtons="true">

                    <slot name="progress"></slot>

                    <template v-slot:custom-buttons>
                        <Button @click="nextStep()" type="black" size="lg" :disabled="!allowNextButton"
                                :class="{ disabled: !allowNextButton }">
                            {{ $tr.nextStepBtn }}
                        </Button>
                    </template>

                </BottomBar>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "./common/Button";
import RadioSelect from "./common/RadioSelect";
import HoverInfo from "./common/HoverInfo";
import BottomBar from "./ProductPickerPage/BottomBar";
import MeasurementsForm from "./Measurements/MeasurementsForm";
import MeasurementsTable from "./Measurements/MeasurementsTable";

export default {
    name: "MeasurementsPage",
    components: {
        MeasurementsTable,
        MeasurementsForm,
        Button,
        RadioSelect,
        HoverInfo,
        BottomBar
    },
    props: [
        "baseCategories",
    ],
    data() {
        return {
            activeTab: 0,
            forceValidate: false
        };
    },
    computed: {
        allowNextButton() {
            return (this.activeTab !== 0 && this.activeTab !== null) || this.$db.measurements["table-size"];
        },

        type() {
            let type;
            switch (this.activeTab) {
                case 1:
                    type = "body";
                    break;
                case 2:
                    type = "shirt";
                    break;
                default:
                    type = "table";
            }
            return type;
        }
    },
    methods: {
        nextStep() {
            this.forceValidate = true;
            if (this.validateTable() || this.validateMeasurements()) {
                this.$set(this.$db.measurements, "type", this.type);
                this.$emit('goToStep', '+1');
            }
        },

        toggleMobileTab(index) {
            if (this.activeTab === index)
                return this.activeTab = null;
            this.activeTab = index;
            this.forceValidate = false;
        },

        validateTable() {
            if (this.activeTab !== 0 && this.activeTab !== null)
                return false;

            return !!this.$db.measurements["table-size"];
        },

        validateMeasurements() {
            if (this.activeTab === 0 || this.activeTab === null)
                return false;

            let baseValue = this.$db.measurements[this.$backendConfig.measurements.baseDefaultsOn];
            let defaults = null;
            let fillByDefaults = [];

            // Default values for selected base measurement value
            if (typeof baseValue !== "undefined")
                defaults = this.$backendConfig.measurements.defaultValues[baseValue];

            for (let measurement of Object.keys(this.$backendConfig.measurements.categories[this.type]))
                if (!this.$db.measurements[measurement]) {
                    // Value is invalid and cannot be defaultly autofilled -> form is invalid
                    if (!defaults || !defaults[measurement] || typeof this.$db.measurements[measurement] !== "undefined")
                        return false;

                    fillByDefaults.push(measurement);
                }

            if (!this.$db.measurements.height)
                return false;

            // Actually use default values
            if (fillByDefaults.length)
                for (let measurement of fillByDefaults)
                    this.$set(this.$db.measurements, measurement, defaults[measurement]);

            return true;
        }
    }
}
</script>
